import { createStore, applyMiddleware, combineReducers } from 'redux';
import rootReducer from '../reducers';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas/sagas';
import actionCache from '../utils/Cache/ActionCacheMiddleware';
import { accountSharingFilterMiddleware, isReadonlyMode } from 'system/SystemUtil';

const sagaMiddleware = createSagaMiddleware();
const combinedReducers = combineReducers(rootReducer);

const store = (preloadedState) => {
    let middlewares = [actionCache, sagaMiddleware];

    if (isReadonlyMode()) {
        // Move Account Sharing Filter upfront
        middlewares.unshift(accountSharingFilterMiddleware);
    }

    const createdStore = createStore(combinedReducers, preloadedState, applyMiddleware(...middlewares));

    sagaMiddleware.run(rootSaga);
    return createdStore;
};

export default store;
